import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const SHOTS = [
    ["/field/cypress.webp", "Under the cypresses", "A tree-lined track through a plot we walked"],
    ["/field/neighbours.webp", "Meeting the neighbours", "A horse and goats grazing on a plot we visited"],
    ["/field/atlantic.webp", "Where the land meets the Atlantic", "Green hills running down to the Atlantic coast"],
    ["/field/villa.webp", "Seeing what it could become", "Walking around an empty modernist villa with a pool"],
    ["/field/on-site.webp", "On site, hard hat optional", "Pieter van Herpen on a construction site with a crane behind him"],
];
const REST = [[-14, -9], [-6, -3], [0, 2], [6, -2], [13, 7]];

function Polaroid({ shot, i, fanned, onOpen }) {
    const [src, title, alt] = shot;
    const mid = i - 2;
    const [rx, rr] = REST[i];
    const t = fanned ? `translateX(calc(-50% + var(--fan) * ${mid})) translateY(${Math.abs(mid) * 8}px) rotate(${mid * 6}deg)` : `translateX(calc(-50% + ${rx}px)) rotate(${rr}deg)`;
    return (
        <button type="button" onClick={() => onOpen(i)} aria-label={`Open photo: ${title}`} data-testid={`field-polaroid-${i}`}
                className="absolute left-1/2 top-3 w-[108px] sm:w-[128px] lg:w-[138px] bg-[#FBFAF5] p-2 pb-8 shadow-[0_16px_34px_-14px_rgba(0,0,0,0.6)] transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-sage"
                style={{ transform: t, zIndex: fanned ? 10 + i : i, transitionDelay: `${Math.abs(mid) * 30}ms` }}>
            <img src={src} alt={alt} loading="lazy" className="aspect-[4/5] w-full object-cover" />
            <span className="absolute left-2.5 right-2.5 bottom-2 font-serif italic text-[10px] sm:text-[11px] text-forest truncate text-left">{title}</span>
        </button>
    );
}

export default function FieldStack() {
    const [open, setOpen] = useState(null);
    return (
        <div data-testid="ic-field">
            <div className="relative h-[190px] sm:h-[215px] lg:h-[225px] [--fan:52%] sm:[--fan:80%] lg:[--fan:84%]" data-testid="field-stack">
                {SHOTS.map((s, i) => <Polaroid key={s[0]} shot={s} i={i} fanned onOpen={setOpen} />)}
            </div>
            <p className="mt-2 text-center mono-label text-cream/50">From the field · <span className="hidden lg:inline">click</span><span className="lg:hidden">tap</span> a photo to enlarge</p>
            <Dialog open={open !== null} onOpenChange={(o) => !o && setOpen(null)}>
                <DialogContent className="max-w-md bg-[#FBFAF5] p-4 pb-6 border-0" data-testid="field-lightbox">
                    {open !== null && (
                        <>
                            <img src={SHOTS[open][0]} alt={SHOTS[open][2]} className="w-full aspect-[4/5] object-cover" />
                            <DialogTitle className="font-serif italic font-normal text-xl text-forest mt-3">{SHOTS[open][1]}</DialogTitle>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}
